'use strict';

module.exports = {
  finished: 'finished',
  error: 'error',
};
